import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";
import { GetTranslation } from "../translations/GetTranslation";
import { isTranslationKey, TranslationKey } from "../translations/TranslationKey";

export default function useNotification() {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const error = (message: string | TranslationKey, error?: any ) => {
    let msg = isTranslationKey(message) ? GetTranslation(intl, message as TranslationKey) : message;
    if (error && error.message) {
        msg = `${msg} Error: ${error.message}`
    }
    enqueueSnackbar(msg, {
      variant: "error",
    });
  };

  const warning = (message: string | TranslationKey) => {
    enqueueSnackbar(isTranslationKey(message) ? GetTranslation(intl, message as TranslationKey) : message, {
      variant: "warning",
    });
  };

  const info = (message: string | TranslationKey) => {
    enqueueSnackbar(isTranslationKey(message) ? GetTranslation(intl, message as TranslationKey) : message, {
      variant: "info",
    });
  };

  const success = (message: string | TranslationKey) => {
    enqueueSnackbar(isTranslationKey(message) ? GetTranslation(intl, message as TranslationKey) : message, {
      variant: "success",
    });
  };
  return {error, warning, info, success};
}
